import type { MediaItem } from 'interfaces/content/Media';

export const parseCaptionWhenAltTextEmpty = (image: MediaItem | string): string => {
  if (typeof image !== 'object') {
    return '';
  }
  return image.altText || image.caption?.replace(/<p>|<\/p>/g, '').trim() || '';
};

// Note: setting this up for now, but ideally we'll have the content cleaned up in backend eventually + remove those empty p/br tags
export const parseContentForEmptySpace = (content: string): string => {
  if (!content) {
    return '';
  }

  return content
    .split('<br>')
    .join('')
    .split('<p>')
    .filter((item) => item !== '&nbsp;</p>')
    .join('<p>');
};
